// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import Menu from "../../Menu";
import SvgMapper from "../../SvgMapper";

import "./RoofHeader.scss";

export default class RoofHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      startHeader: true
    };
  }

  showMenu(event) {
    
    event.preventDefault();
    this.setState({
      active: true
    });
  }
  toggleMenu() {
    this.setState({
      active: !this.state.active
    });
  }

  closeMenu() {
    this.setState({
      active: false
    });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.resizeHeaderOnScroll);
  }

  resizeHeaderOnScroll = () => {

    const distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 145,
      headerEl = document.querySelector("#roof-main");
    if (
      distanceY >= 0 + 145 ||
      distanceY <= 0 - 145
    ) {
      this.setState({ startHeader: false });

    } else {
      this.setState({ startHeader: true });

    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.startHeader ? (
          <div>
            <header id="roof-main" className="main-header no-background">
              <div className="header big-main__header container row roof-row">
                <div className="row">
                  <div className="col-6 header-left__col">
                    <div className="header-left__container">
                      <img
                        className="evomer-logo"
                        src="/img/evomer-logo-szybciej.svg"
                        alt="Evomer logo"
                      ></img>
                    </div>
                  </div>
                  <div className="col-6 header-right__col">
                    <div className="header-right__container hidden-img">
                      <img src="/img/tytan-logo.svg"></img>
                    </div>
                    <span
                      onClick={this.showMenu.bind(this)}
                      className="af-icon-menu red-burger"
                    ></span>

                  </div>
                </div>
                <div className="row bottom-header__row">
                  <div className="col-12 header-bottom__col">
                    <div className="bottom-col">
                      <div className=" col-12 header-title__container">
                        <div className="header-title__roof">
                          <h2 className="white-med__header red-bg">
                            Nawet w jeden dzień !
                          </h2>
                          <h1 className="red-big__header">2 x szybsza</h1>
                          <h2 className="white-sm__header">Renowacja dachu</h2>
                        </div>
                      </div>
                      <div className="benefits-container container">
                        <div className="benefit-container">
                          <img
                            src="/img/safety-light.svg"
                            className="landing-icon"
                          />
                          <div className="icon-description">
                            Bezpieczne dla termoizolacji
                          </div>
                        </div>
                        <div className="benefit-container">
                          <img
                            src="/img/thumb-light.svg"
                            className="landing-icon"
                          />
                          <div className="icon-description">
                            Łatwe w aplikacji
                          </div>
                        </div>
                        <div className="benefit-container">
                          <img
                            src="/img/fire-light.svg"
                            className="landing-icon"
                          />
                          <div className="icon-description">
                            Niepalne - bez rozpuszczalnikow
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <Menu
              menu={this.state.active}
              closeMenu={this.closeMenu.bind(this)}
              activeLink={this.props.activeLink}
            />
          </div>
        ) : (
          <div>
            <header id="roof-main" className="main-header">
              <div className="header row ">
                <div className="col-6 header-left__col">
                  <div className="header-left__container">
                    <img
                      className="evomer-logo"
                      src="/img/evomer-logo-szybciej.svg"
                      alt="Evomer logo"
                    ></img>
                  </div>
                </div>
                <div className="col-6 header-right__col">
                  <div className="header-right__container">
                    <img src="/img/tytan-logo.svg"></img>
                  </div>
                  <span
                    onClick={this.showMenu.bind(this)}
                    className="af-icon-menu red-burger"
                  ></span>
                </div>
              </div>
            </header>
            <Menu
              menu={this.state.active}
              closeMenu={this.closeMenu.bind(this)}
              activeLink={this.props.activeLink}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/RoofHeader/RoofHeader.js